import axios from "axios";
class ParseAxios {
  constructor() {
    this.baseURL = import.meta.env.VITE_PARSE_SERVER_URL;
    this.appId = import.meta.env.VITE_PARSE_APP_ID;
  }
  post(url, data, user) {
    let option = {
      method: 'POST',
      url: `${this.baseURL}/${url}`,
      data: data,
      headers: { 'X-Parse-Application-Id': this.appId },
    }
    let cachedToken = null;
    try { cachedToken = localStorage.getItem("sessionToken"); } catch (e) { /* private browsing */ }
    if (user?.sessionToken) {
      option.headers["X-Parse-Session-Token"] = user.sessionToken
    } else if (cachedToken) {
      option.headers["X-Parse-Session-Token"] = cachedToken
    } else {
      option.headers["X-Parse-Session-Token"] = ""
    }
    return axios(option)
  }
}
export default new ParseAxios();
